export const navigate = (href) => {
    if (typeof window !== 'undefined') {
        if (!window.__navigateBlockKit) {
            window.__navigateBlockKit = (href) => {
                window.location.href = href;
            };
        }
        window.__navigateBlockKit(href);
    }
};
//# sourceMappingURL=navigate.js.map